/**
 * UI-тексты страницы транспорта (TransportPageContent) — вертикаль-специфика.
 * Общие надзаголовки/якоря/теги/кнопки берутся из servicePage (sp.*).
 * Интерполируемые строки — функции; склонения остаются в компоненте.
 */
export const transportPage = {
    en: {
        // Hero
        heroChoose: 'Choose transport',
        heroHow: 'How to book',
        // Subnav
        leaf: 'Transport',
        // Anchors (vertical-specific labels not covered by servicePage)
        anchorFeatures: 'Services',
        anchorProviders: 'Where to book',
        anchorHow: 'How to book',
        // Section eyebrows/titles
        featuresEyebrow: 'Services',
        featuresTitle: 'What you get',
        providersEyebrow: 'Services',
        providersTitle: 'Where to book',
        anchorAirports: 'Airports',
        airportsEyebrow: 'From the airport',
        airportsTitle: 'Airport transfers',
        airportsLead: 'Transfer, taxi and car rental straight from arrivals — routes and prices on each airport page.',
        airportCardDesc: 'Transfers to the resorts, taxi, buses and car hire at the terminal.',
        providersLead: 'Pick a travel mode and compare trusted providers.',
        modeAria: 'Travel mode',
        modeAll: 'All',
        stepsTitle: 'How to book',
        promosTitle: 'Transport promo codes',
        promoLead: 'Current discounts on transfers and rentals — tap “Show code” to copy.',
        articlesTitle: 'Transport articles',
        articlesLead: 'Getting around: transfers, car rental and public transport.',
        // Transport mode labels
        mode: { transfer: 'Transfers & taxi', rental: 'Rental', transit: 'Train/bus', flight: 'Flights' },
        // Bottom CTA
        ctaEyebrow: 'Getting around made easy',
        ctaTitle: (to) => `Plan your trips${to ? ` around ${to}` : ''}.`,
        ctaBtn: 'Choose transport →',
    },
    ru: {
        heroChoose: 'Выбрать транспорт',
        heroHow: 'Как заказать',
        leaf: 'Транспорт',
        anchorFeatures: 'Сервисы',
        anchorProviders: 'Где забронировать',
        anchorHow: 'Как заказать',
        featuresEyebrow: 'Сервисы',
        featuresTitle: 'Что доступно',
        providersEyebrow: 'Сервисы',
        providersTitle: 'Где забронировать',
        anchorAirports: 'Аэропорты',
        airportsEyebrow: 'Из аэропорта',
        airportsTitle: 'Трансфер из аэропорта',
        airportsLead: 'Трансфер, такси и аренда авто прямо от выхода из терминала — маршруты и цены на странице каждого аэропорта.',
        airportCardDesc: 'Трансферы до курортов, такси, автобусы и аренда авто у терминала.',
        providersLead: 'Выберите способ передвижения и сравните проверенных провайдеров.',
        modeAria: 'Способ передвижения',
        modeAll: 'Все',
        stepsTitle: 'Как заказать',
        promosTitle: 'Промокоды на транспорт',
        promoLead: 'Актуальные скидки на трансферы и аренду — нажмите «Показать код», чтобы скопировать.',
        articlesTitle: 'Статьи о транспорте',
        articlesLead: 'Как передвигаться по стране: трансферы, аренда авто и общественный транспорт.',
        mode: { transfer: 'Трансфер/такси', rental: 'Аренда', transit: 'Поезд/автобус', flight: 'Авиа' },
        ctaEyebrow: 'Передвижение без забот',
        ctaTitle: (to) => `Спланируйте поездки${to ? ` по ${to}` : ''}.`,
        ctaBtn: 'Выбрать транспорт →',
    },
};
